import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { TipoProcessoForm } from "./TipoProcessoForm";
import { useGetTipoProcessoQuery, useUpdateTipoProcessoMutation } from "./tipoProcessoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useParams } from "react-router-dom";
import { errorMonitor } from "events";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { IStipoProcesso, TipoProcesso } from "../../types/tipoProcesso/TipoProcesso";



export const TipoProcessoEdit = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()


    const [updateTipoProcesso, status] = useUpdateTipoProcessoMutation();


    const id = useParams().id || "";
    const { data, isFetching, error } = useGetTipoProcessoQuery(id);
    const [tipoProcesso, setTipoProcesso] = useState<TipoProcesso>(IStipoProcesso);


    useEffect(() => {
        if (data) {
            setTipoProcesso(data);
        } else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        } else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        } else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }
    }, [data, error, isFetching])



   
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setTipoProcesso((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await updateTipoProcesso(tipoProcesso);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não alterado!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro alterado com sucesso!", { variant: "success" })
            navigate(configUrls.TIPO_PROCESSO_LIST_RT);
        }
    }, [status]);


    return (
        <>
            <Paper >

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Tipos de Processos - Edição
                </Typography>

                <TipoProcessoForm
                    data={tipoProcesso}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
            </Paper>
        </>
    );
};
